export default "__VITE_ASSET__CYqdRGeB__"